import { client } from '../';

const AdGroupsQuery = `
  query($search: JSON!, $order: [String!], $page: Int!, $limit: Int!) {
    adGroups(
      search: $search
      order: $order
      page: $page
      limit: $limit
    ) {
      data {
        id, name, remoteId, remoteStatus
        adCampaign { id, name, remoteId, remoteStatus, objectiveName }
        adAccount { id, name, remoteId, remoteStatus }
        channel { id, name }
      }
      paging { totalCount, totalPages }
    }
  }
`;

export const queryAdGroups = async (variables, operationContext = {}) => {
  const { data, error } = await client
    .query(AdGroupsQuery, variables, operationContext)
    .toPromise();
  if (error) {
    throw new Error(error);
  }

  return data.adGroups;
};
